import type { ShopDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";

type DeleteExportMethodParams = {
  exportId: string;
};

export default function useDeleteExportMethod(shop: ShopDto) {
  const invalidateShop = useInvalidateShop(shop.id);

  return useApiMutation("delete", "/shops/{shopId}/exports/{exportId}", {
    invalidate: invalidateShop,
    mapVariables: ({ exportId }: DeleteExportMethodParams) => ({
      params: { path: { shopId: shop.id, exportId } },
    }),
  });
}
